import type { FaireProductEntity } from "../../entity_types/product";

export const p_9xptsrgv2f: FaireProductEntity = {
  token: "p_9xptsrgv2f",
  type: "product",
  name: "Vintage Lined Notebook Greetings from Arizona, Grand Canyon - Paperback",
  brandToken: "b_4d6jvdz5w2",
  brandName: "Books by splitShops",
  imageUrl:
    "https://cdn.faire.com/fastly/fc22c62d32f69d9ae2acb889ec9e98e254fe62d7b9527892082cd94bfd0b75e5.png",
  galleryImageUrls: [],
  priceDollars: 15.51,
  description:
    "by Found Image Press (Producer)\n\nIntroducing the Vintage Notebook: Greetings from Arizona, Grand Canyon, a delightful companion for all your writing endeavors. Featuring 150 lined pages, immerse yourself in the charm of a classic vintage travel postcard illustration adorning its cover. With its full-color decorative vintage art and versatile functionality, this notebook is an ideal companion for journaling, planning trips, tackling writing projects, organizing to-do lists, or simply capturing thoughts on any occasion. Found Image Press Vintage Journals take you on a nostalgic journey, featuring carefully curated vintage art that celebrates your favorite places, hobbies, and interests. The front cover showcases a captivating classic piece of art sourced from our vast collection of over 60,000 pictures, meticulously selected to transport you to a bygone era. Immerse yourself in the allure of the past and thoughtfully crafted to inspire and accompany your creative ventures. Details: A5 5.8 x 8.2 inches; 150 lined opaque pages; Soft matte finish; Soft matte finish\nNumber of Pages: 152 Dimensions: 0.35 x 8.27 x 5.83 IN Publication Date: August 01, 2023",
  tags: [],
  msrpDollars: 19.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:11.853Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
